import { Component, OnInit, Output, Input } from '@angular/core';
import { PassDataService } from '../../services/pass-data.service';

@Component({
  selector: 'header-title-cmp',
  templateUrl: './header-title.component.html',
})
export class HeaderTitleComponent implements OnInit {
  @Input('isActive') isActive: string = '';

  @Input('title') title: string = '';
  @Input('total') total: string = '0';

  constructor() {}

  ngOnInit(): void {}
}
